import React from "react";
import {
  WidgetFrame,
  WidgetGrid,
  WidgetGridModel,
} from "../../../personal-studio-components/studio";
import "react-calendar/dist/Calendar.css";
import AcademicVacation from "./AcademicVacation.jsx";

function SabbaticalModel() {
  const model = new WidgetGridModel({
    widget: {
      AcademicVacation: <AcademicVacation />,
    },
    grid: [
      {
        id: "AcademicVacation",
        colspan: 2,
        visible: true,
      },
    ],
  });
  return <WidgetGrid {...model} />;
}

export default SabbaticalModel;
